import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { auth } from '@/store/auth/index.js';
import { cart } from '@/store/cart/index.js';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: 'user',
    storage: window.sessionStorage,
    paths: ['auth.currentUser'],
    // clearOnDestroy: true
  })],
  modules: {
    auth,
    cart
  }
})
